import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-v1g_detail",
  "use": "icon-v1g_detail-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-v1g_detail\"><clipPath id=\"icon-v1g_detail_a\"><path d=\"m0 0h14v14h-14z\" /></clipPath><g clip-path=\"url(#icon-v1g_detail_a)\" fill=\"#999\"><path d=\"m7 13.333c-3.492 0-6.333-2.841-6.333-6.333s2.84-6.333 6.333-6.333 6.333 2.841 6.333 6.333-2.841 6.333-6.333 6.333zm0-11.666c-2.941 0-5.334 2.392-5.334 5.333 0 2.94 2.393 5.333 5.333 5.333s5.334-2.392 5.334-5.333-2.393-5.333-5.333-5.333z\" /><path d=\"m7.146 10.417c-.276 0-.5-.224-.5-.5v-3h-.084c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.292c.437 0 .792.355.792.792v3.208c0 .277-.224.5-.5.5zm-.292-3.5h.01z\" /><path d=\"m7 5.25c.483 0 .875-.392.875-.875s-.392-.875-.875-.875-.875.392-.875.875.392.875.875.875z\" /><path d=\"m8.312 10.417h-2.333c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2.333c.276 0 .5.224.5.5s-.224.5-.5.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/v1g_detail.svg
// module id = rNcH
// module chunks = 87